import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components';
import { countDownFn } from '../../utils/utils';

let timer = null ;
export default function DayCountDown() {

 const [time,setTime] = useState()

const initTime = dayjs('2024-05-30 00:00:00')
const calcTime = () => {
    //获取当前时间
    const now = dayjs();
      // console.log('xxx',now.diff(initTime) % (7 * 24 * 3600 * 1000))
      // 当前时间到初始时间的时间差不满足7天或7天的倍数，
      let timeCha = (7 * 24 * 60 * 60 * 1000 ) - ( now.diff(initTime) % (7 * 24 * 60 * 60 * 1000 ))
        const days = Math.floor(timeCha / (24 * 60 * 60 * 1000));
        const hours = Math.floor((timeCha % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
        const minutes = Math.floor((timeCha % (60 * 60 * 1000)) / (60 * 1000));
        const seconds = Math.floor((timeCha % (60 * 1000)) / 1000);
        // console.log(days + '天' + hours + '时' + minutes + '分' + seconds + '秒');
        let time = days + '天' + hours + '时' + minutes + '分' + seconds + '秒'
        setTime(time)
}
useEffect(() => {
    calcTime()
    timer = setInterval(() => {
        calcTime()
    }, 1000);

    return () => {
        clearInterval(timer)
    }
}, [])

  return (
    <Block className='w-full md:w-[637px] max-w-[637px] lg:w-[637px] xl:w-[637px] mx-auto rounded-[8px] lg:rounded-[16px] xl:rounded-[16px]  h-[36px] md:h-[56px] lg:h-[36px] xl:h-[56px] xl:mb-[52px] lg:mb-[24px] mb-6 flex justify-center items-center'>
        <p className='text-[#F74B1A] text-xl'>-80% 火热促销中！特价结束倒计时{time}</p>
    </Block>
  )
}
const Block = styled.div`
background-color: rgba(247, 75, 26, 0.1);
`